<script setup lang="ts">
import Login from "@/components/Login.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
</script>

<template>
  <Header />
  <Login />
  <Footer />
</template>
